import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { DisplayProps, PositionProps, ZIndexProps } from 'styled-system';
import {
  borderColor,
  borderLeft,
  borderRight,
  borderStyle,
  borderTop,
  borderWidth,
  color,
  display,
  left,
  position,
  space,
  width,
  zIndex,
} from 'styled-system';

import type { Color } from '../../theme/colors/types';
import { getForwardPropOpts } from '../../theme/helpers/forward-props';
import { themeHeight } from '../../theme/system-utilities';
import { HeadlineH7 } from '../Typography';

export interface TitleProps {
  text?: string;
  color?: Color;
  borderColor?: string;
}

const StoererWrapper = styled.span<any>`
  ${space};
`;

const stoererWrapperStyles: ComponentProps<typeof StoererWrapper> = {
  pb: ['sp_4', '6px', 'sp_8', '10px'],
};

const StoererText = styled(HeadlineH7, getForwardPropOpts(['color']))<
  DisplayProps & ZIndexProps & PositionProps
>`
  ${display};
  ${position};
  ${space};
  ${zIndex};
  ${color};
`;

const stoererTextStyles: ComponentProps<typeof StoererText> = {
  zIndex: 1,
  px: 'sp_4',
  position: 'relative',
  display: 'inline',
};

const StoererBorder = styled.span<any>`
  ${position};
  ${borderColor};
  ${borderWidth};
  ${borderStyle};
  ${themeHeight};
  ${width};
  ${zIndex};
  ${left};
  ${borderRight};
  ${borderLeft};
  ${borderTop};
  ${space};
`;

const stoererBorderStyles: ComponentProps<typeof StoererBorder> = {
  left: 0,
  width: '100%',
  themeHeight: ['sp_12', '14px', 'sp_16', '18px'],
  borderWidth: ['14px', '16px', '20px', '22px'],
  borderStyle: 'solid',
  borderColor: 'sys.neutral.background.default',
  position: 'absolute',
  zIndex: -1,
  borderRight: 'none',
  borderLeft: 'none',
  borderTop: 'none',
  mt: '-4px',
};

const Stoerer = ({ borderColor: stoererColor, color: textColor, text, ...props }: TitleProps) =>
  text ? (
    <StoererWrapper data-testid="stoerer" {...stoererWrapperStyles} {...props}>
      <StoererText {...stoererTextStyles} color={textColor}>
        <StoererBorder {...stoererBorderStyles} borderColor={stoererColor} />
        {text}
      </StoererText>
    </StoererWrapper>
  ) : null;

export default Stoerer;
